import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '../permissions'

export enum BLOCK_NOTE_MODAL_PERMISSION {
  EDIT = 'EDIT',
  EMOJI_REACTIONS = 'EMOJI_REACTIONS',
}

export const getBlockNoteModalPermissionsMatrix = (): Record<
  BLOCK_NOTE_MODAL_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [BLOCK_NOTE_MODAL_PERMISSION.EDIT]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
    [BLOCK_NOTE_MODAL_PERMISSION.EMOJI_REACTIONS]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TRIAL_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.FREE_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.FREE_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.NO },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
